import arms from "@arms/rum-browser";

export class NebulaSiteArmsService {
  public install(): void {
    void arms.init({
      pid: import.meta.env.VITE_ARTMS_KEY,
      endpoint: "https://cd44lwy8vy-default-cn.rum.aliyuncs.com",
      env: "prod",
      tracing: { enable: true },
    });
  }
}

export default new NebulaSiteArmsService();
